import { render, staticRenderFns } from "./ApprovedDnsList.vue?vue&type=template&id=8d9e399a&"
import script from "./ApprovedDnsList.vue?vue&type=script&lang=js&"
export * from "./ApprovedDnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports